import React from "react";
import PropTypes from "prop-types";
import { useTimesheetList } from "../../hooks/useTimesheetList";
import TimesheetListView from "./TimesheetListView";
import { useAuth } from "../../context/authcontext";

function TimesheetListContainer(props) {
    const { auth } = useAuth();
    const hookProps = useTimesheetList(props);

    // Pass userId, projectId, projectRole, and auth explicitly to the view
    return <TimesheetListView
        {...hookProps}
        {...props}
        auth={auth}
        timesheets={hookProps.timesheets}
        filterStatus={hookProps.filterStatus}
        setFilterStatus={hookProps.setFilterStatus}
        filterUser={hookProps.filterUser}
        setFilterUser={hookProps.setFilterUser}
        sortOrder={hookProps.sortOrder}
        setSortOrder={hookProps.setSortOrder}
        loading={hookProps.loading}
        error={hookProps.error}
        showDeleteModal={hookProps.showDeleteModal}
        setShowDeleteModal={hookProps.setShowDeleteModal}
        confirmDelete={hookProps.confirmDelete}
        handleDeleteConfirmed={hookProps.handleDeleteConfirmed}
        handleApprove={hookProps.handleApprove}
        handleReject={hookProps.handleReject}
        projectId={hookProps.projectId}
        userId={auth?.user?.id || auth?.userId}
        projectRole={hookProps.projectRole}
        isOwner={auth?.role === "owner"}
        isFinance={auth?.role === "finance"}
        isVoorman={auth?.role === "voorman"}
        isOwnerOrFinance={auth?.role === "owner" || auth?.role === "finance"}
        isVoormanOnAnyProject={hookProps.isVoormanOnAnyProject}
        filterProject={hookProps.filterProject}
        setFilterProject={hookProps.setFilterProject}
    />;
}

export default TimesheetListContainer;

TimesheetListContainer.propTypes = {
    statusFilter: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    projectRole: PropTypes.string,
};
